var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292119",
    cx: 11.8288,
    cy: 12.0937,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(119.993 11.8288 12.0937)",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292122",
    cx: 11.6509,
    cy: 12.1134,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(-180 11.6509 12.1134)",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292118",
    cx: 11.9046,
    cy: 11.8633,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(59.8665 11.9046 11.8633)",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.e0c078e147f990e23af083134cc58824.svg";
export { ForwardRef as ReactComponent };